import React from "react";
import { useTranslation } from "react-i18next";
import "./AlumniSection.css";

export default function AlumniSection() {
  const { t } = useTranslation();

  return (
    <section
      className="alumni-section"
      aria-label={t(
        "home.alumni.ariaLabel",
        "Trusted by talent from leading global companies"
      )}
    >
      <div className="alumni-inner">
        <h2 className="alumni-title">
          {t("home.alumni.titlePart1", "Trusted By Talent From")}{" "}
          <span className="alumni-accent">
            {t("home.alumni.titleAccent", "Leading Global Companies")}
          </span>
        </h2>

        <div className="alumni-logo-strip">
          <img
            className="alumni-logo-image"
            src="/Image/Hero/alumi_logos.svg" 
            alt={t(
              "home.alumni.logoAlt",
              "Logos of global companies whose talent trusts our platform"
            )}
          />
        </div>
      </div>
    </section>
  );
}
